export default function Backgrounds() {
    return (
        <>
        <div className="parent">
            <div className="cld4">
                <a href="/"><button className="left-slide"><img src="back_arrow.svg" /></button></a>
                <div className="sub-child">
                    <p className="bg">Backgrounds</p>
                </div>
                <div className="comp">
                    <div className="bg01">
                        <img src="Bd Design.jpg" />
                    </div>
                    <div className="bg01">
                        <img src="Untitled-7.3.png" />
                    </div>
                    <div className="bg01">
                        <img src="Untitled-7.2.png" />
                    </div>
                    <div className="bg01">
                        <img src="illustration90.jpg" />
                    </div>
                    <div className="bg01">
                        <img src="Arcane Art Style.png" />
                    </div>
                    <div className="bg01">
                        <img src="illustration195.2.jpg" />
                    </div>
                    <p className="thb">Thumbnails</p>
                    <div className="bg01">
                        <img src="temple design 1st.png" />
                    </div>
                    <div className="bg01">
                        <img src="temple design 2nd.png" />
                    </div>
                    <div className="bg01">
                        <img src="temple design 3rd.png" />
                    </div>
                    <div className="bg01">
                        <img src="castle design 1st.png" />
                    </div>
                    <div className="bg01">
                        <img src="castle design 2nd.png" />
                    </div>
                    <div className="bg01">
                        <img src="castle design 3rd.png" />
                    </div>
                    <div className="bg01">
                        <img src="castle design 4th.png" />
                    </div>
                    <div className="bg01">
                        <img src="castle design 5th.png" />
                    </div>
                    <div className="bg01">
                        <img src="bg thumbnails 1st.png" />
                    </div>
                    <div className="bg01">
                        <img src="bg thumbnails 2nd.png" />
                    </div>
                    <div className="bg01">
                        <img src="bg thumbnails 3rd.png" />
                    </div>
                    <p className="thb">Background Study</p>
                    <div className="bg01">
                        <img src="Untitled-3.png" />
                    </div>
                    <div className="bg01">
                        <img src="Untitled-3.3.png" />
                    </div>
                    <div className="bg01">
                        <img src="Untitled-3.4.png" />
                    </div>
                    <div className="bg01">
                        <img src="Untitled-3.5.png" />
                    </div>
                    <div className="bg01">
                        <img src="Untitled-3.6.png" />
                    </div>
                    <div className="bg01">
                        <img src="Untitled-3.7.png" />
                    </div>
                </div>
            </div>
        </div>
        </>
    );
}